import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';

import * as styles from './LocationModal.css';

interface ILocationModalProps extends React.PropsWithChildren {
  top: React.ReactNode;
  content: React.ReactNode;
  bottom: React.ReactNode;
  onClose: () => void;
}

export const LocationModal: React.FC<ILocationModalProps> = ({ top, content, bottom, onClose }) => {
  return (
    <ModalWindow onClose={onClose} open width="calc(100% - 40px)" maxWidth={1040}>
      <div className={styles['container']}>
        <div className={styles['top']}>{top}</div>
        {content}
        <div className={styles['divider']} />
        {bottom}
      </div>
    </ModalWindow>
  );
};
